import 'zone.js';
import '@angular/localize/init';